"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COOKIE_KEYS = exports.COMMON_CROSS_TEAM_EVENT_NAMES = exports.ENVIRONMENT = exports.SEGMENT_METHODS = void 0;
;
var SEGMENT_METHODS;
exports.SEGMENT_METHODS = SEGMENT_METHODS;

(function (SEGMENT_METHODS) {
  SEGMENT_METHODS["TRACK"] = "track";
  SEGMENT_METHODS["PAGE"] = "page";
  SEGMENT_METHODS["IDENTIFY"] = "identify";
})(SEGMENT_METHODS || (exports.SEGMENT_METHODS = SEGMENT_METHODS = {}));

var ENVIRONMENT;
exports.ENVIRONMENT = ENVIRONMENT;

(function (ENVIRONMENT) {
  ENVIRONMENT["PROD"] = "PROD";
  ENVIRONMENT["QA"] = "QA";
  ENVIRONMENT["DEV"] = "DEV";
  ENVIRONMENT["LOCAL"] = "LOCAL";
  ENVIRONMENT["E2E"] = "E2E";
})(ENVIRONMENT || (exports.ENVIRONMENT = ENVIRONMENT = {}));

;
var COMMON_CROSS_TEAM_EVENT_NAMES;
exports.COMMON_CROSS_TEAM_EVENT_NAMES = COMMON_CROSS_TEAM_EVENT_NAMES;

(function (COMMON_CROSS_TEAM_EVENT_NAMES) {
  COMMON_CROSS_TEAM_EVENT_NAMES["UX_ACTION_PERFORMED"] = "ux_action_performed";
  COMMON_CROSS_TEAM_EVENT_NAMES["REGISTRATION_FORM_SUBMITTED"] = "registration_form_submitted";
  COMMON_CROSS_TEAM_EVENT_NAMES["REGISTRATION_FAILED"] = "registration_failed";
  COMMON_CROSS_TEAM_EVENT_NAMES["FORM_SUBMITTED"] = "form_submitted";
  COMMON_CROSS_TEAM_EVENT_NAMES["NAVIGATION_CLICKED"] = "navigation_clicked";
  COMMON_CROSS_TEAM_EVENT_NAMES["TOP_NAV_SEARCH"] = "top_nav_search";
})(COMMON_CROSS_TEAM_EVENT_NAMES || (exports.COMMON_CROSS_TEAM_EVENT_NAMES = COMMON_CROSS_TEAM_EVENT_NAMES = {}));

;
;
;
;
var COOKIE_KEYS;
exports.COOKIE_KEYS = COOKIE_KEYS;

(function (COOKIE_KEYS) {
  COOKIE_KEYS["SEGMENT"] = "segmentSessionId";
  COOKIE_KEYS["DOT_COM"] = "__session.data";
  COOKIE_KEYS["AUID"] = "auid";
  COOKIE_KEYS["AMPLITUDE_SESSION_COOKIE_KEY"] = "amplitudeSessionId";
})(COOKIE_KEYS || (exports.COOKIE_KEYS = COOKIE_KEYS = {}));
//# sourceMappingURL=types.js.map